import { Component, Vue } from 'vue-property-decorator';
import { supportEmail } from '@/main';

@Component({
  name: 'contact-support',
})
export default class ContactSupportComponent extends Vue {
  public mailLink = `mailto:${supportEmail}`;
  public supportEmail = supportEmail;
}
